import React, { FunctionComponent } from 'react';
import classes from './GeneralPageLayout.module.css';
import { SpeedDialDiv } from '../component/speed-dial/SpeedDialDiv';

interface Props {
  navigationBar?: React.ReactNode;
  elementCentr?: React.ReactNode;
}

export const GeneralPageLayout: FunctionComponent<Props> = ({
  navigationBar,
  elementCentr,
}) => (
  <div style={{ userSelect: 'none' }} className={classes.myDiv}>
    <div className={classes.container}>
      <div className={classes.elementBar}>{navigationBar}</div>
      <div className={classes.elementCentr}>{elementCentr}</div>
    </div>
    <div style={{ position: 'fixed', right: 10, bottom: 10 }}>
      <SpeedDialDiv />
    </div>
  </div>
);

GeneralPageLayout.defaultProps = {
  navigationBar: undefined,
  elementCentr: undefined,
};
